export const TAB_CHANGE_EVENT_NAME = 'tabChange'
export const TEST_ID = 'base-tabs'
export const TAB_INPUT_TEST_ID = 'base-tabs-input'
